// extracted by mini-css-extract-plugin
export default {"customLink":"PrivacyPolicy_customLink__23tQa","privacyPolicy":"PrivacyPolicy_privacyPolicy__erXRS"};